if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    const cartDrawer = document.querySelector('.cart-drawer-container');

    if (cartDrawer) {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
        if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'class'
        ) {
            if (cartDrawer.classList.contains('menu-opening')) {
                setTimeout(() => {
                    BSS_B2B.handleCartCheckoutBtn(BSS_B2B.shopData);
                }, 600);
            }
        }
        });
    });

    observer.observe(cartDrawer, {
        attributes: true, 
    });
    }
}
